<template>
  <div class="modal" :class="{'is-active': active}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <span class="close cursor-pointer is-small" @click="cancelDownload()"><i class="fal fa-times" /></span>
      <div class="modal-header title is-uppercase is-left" qa="modal-header">
        <i class="fal fa-download"></i> Downloading File
      </div>
      <section class="modal-card-body footerless">
        <progress class="progress is-primary is-marginless" :value="value" :max="max">
          {{ percentage }}
        </progress>
        <span class="help is-pulled-right">{{ percentage }}% Complete</span>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      active: false,
      value: 0,
      max: 100
    }
  },
  computed: {
    percentage: function () {
      return Math.round((this.value / this.max) * 100.0).toFixed(0)
    }
  },
  methods: {
    setValue: function (value) {
      this.value = value
    },
    setMax: function (max) {
      this.max = max
    },
    toggle: function () {
      this.active = !this.active
    },
    reset: function () {
      this.value = 0
      this.max = 100
    },
    cancelDownload: function () {
      this.toggle()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';

.modal-card {
  padding: 2rem;
  background-color: white;
  max-width: 600px;
}

.modal-card-body {
  padding: 20px 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.modal-header {
  font-size: .9rem;
  padding-bottom: 20px;
  margin-bottom: 0;
  border-bottom: 1px solid $grey-lighter;
}

.modal-header:before {
  content: "";
  background: $primary;
  position: absolute;
  top: 68px;
  height: 1px;
  width: 87px;
}
.close {
  position: absolute;
  right: 1rem;
  top: 0.5rem;
  font-size: 1.2rem;
}
</style>
